import React, { useState, useEffect } from "react";
import { Container, HomeFornada, TituloPagina } from "./styles";
import Swal from "sweetalert2";
import { URLBunge } from "../../Componentes/Config";
import { LogAcesso } from "../../Componentes/Funcoes";
import {
  MDBBtn,
  MDBDataTable,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBRow,
  MDBCol,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import { useHistory, useLocation } from "react-router-dom";
import HeaderPortalVendedor from "../HeaderPortalVendedor";
import Carregando from "../../Componentes/Carregando";

import MenuPrinc from "../../Componentes/MenuPrinc";
import { HiOutlineArrowSmLeft } from "react-icons/hi";

import "mdbreact/dist/css/mdb.css";

import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function FiltroPush() {
  const TOKEN = localStorage.getItem("c_token");
  const EMAIL_USUARIO = localStorage.getItem("c_email");
	const location = useLocation();

  const PushId = location.state?.PushId;
	const message = location.state?.message;
	const title = location.state?.title;

  const history = useHistory();
  const [carregando, setCarregando] = useState(true);
  const [departamento, setDepartamento] = useState(0);

  const [vendedores, setVendedores] = useState([]);
  const [vendedoresTotal, setVendedoresTotal] = useState([]);
  const [vendEscolhidos, setVendEscolhidos] = useState([]);

  const [gerentes, setGerentes] = useState([]);
  const [gerentesTotal, setGerentesTotal] = useState([]);
  const [gerenteEscolhidos, setGerenteEscolhidos] = useState([]);

  const [supervisores, setSupervisores] = useState([]);
  const [supervisoresTotal, setSupervisoresTotal] = useState([]);
  const [supEscolhidos, setSupEscolhidos] = useState([]);

  const [cnpj, setCnpj] = useState("");
  const [codigoSap, setCodigoSap] = useState("");

  const [colunasExcel, setColunasExcel] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [listaSelect, setListSelect] = useState({ sap: "" });
  const [abreModal, setAbreModal] = useState(false);

  function toggle(cliente) {
    if (cliente != null) {
      setListSelect(cliente);
    }

    setAbreModal((oldValue) => !oldValue);
  }

  async function buscaVendedores() {
    setCarregando(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${URLBunge}/api/Vendedores/ProcuraVendedores/` + EMAIL_USUARIO,
      requestOptions
      )
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso) {
          
          const departamentoUsuario = result.departamento;
          setDepartamento(departamentoUsuario);

          // OBS: ESTUDAR MELHOR FORMA DE GUARDAR O DEPARTAMENTO PARA USAR NO HEANDER
          localStorage.setItem("@p_departamento-numero", departamentoUsuario);

          if (departamentoUsuario === 10) {
            fetch(
              `${URLBunge}/api/Usuarios/BuscarUserCAO/` + EMAIL_USUARIO,
              requestOptions
            )
              .then((response) => response.json())
              .then((result) => {
                var VendEscolhidos = [];
                VendEscolhidos.push(parseInt(result.id));

                setVendEscolhidos(VendEscolhidos);
              })
              .catch((error) => {
                console.log("error", error);
                setCarregando(false);
              });
          } else {
            if (departamentoUsuario === 11) {
              var gerentesTotal = [];
              var gerentes = [];

              if (result.gerentes != null) {
                result.gerentes.map((ger) => {
                  gerentesTotal.push(ger);
                  gerentes.push({
                    id: ger.id,
                    nome: ger.nome,
                  });
                });

                setGerentesTotal(gerentesTotal);
                setGerentes(gerentes);
              }
            }

            var supervisores = [];
            var supervisoresTotal = [];

            if (result.supervisores != null) {
              result.supervisores.map((sup) => {
                supervisoresTotal.push(sup);
                supervisores.push({
                  id: sup.id,
                  nome: sup.nome,
                });
              });

              setSupervisores(supervisores);
              setSupervisoresTotal(supervisoresTotal);
            }

            var vendedores = [];
            var vendedoresTotal = [];

            if (result.vendedores != null) {
              result.vendedores.map((ven, i) => {
                vendedoresTotal.push(ven);
                vendedores.push({
                  idPai: ven.id,
                  id: ven.id,
                  nome: ven.nome,
                });
              });
              setVendedores(vendedores);
              setVendedoresTotal(vendedoresTotal);
            }
          }
        } else {
          setSupervisores([]);
          setVendedores([]);
        }

        // setCarregando(false);
      })
      .catch((error) => {
        console.log("ERRO", error);
        setCarregando(false);
      });
  }

  function carregaLojas(tipo, supervisoresFiltrados) {
    if (tipo === "SAP" && cnpj.trim() === "" && codigoSap.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Digite algum valor no campo de pesquisa.",
      });

      return;
    }

    setCarregando(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var dadosBusca = {
      idProjeto: 2329681,
      GerentesId: [],
      SupervisoresId: [],
      VendedoresId: [],
      modalNumber: false,
    };

    if (tipo !== "SAP") {
      if (supervisoresFiltrados) {
        dadosBusca.SupervisoresId = supervisoresFiltrados.map((sup) => {
          return sup.id;
        });
      } else {
        dadosBusca.SupervisoresId = supervisores.map((sup) => {
          return sup.id;
        });
      }

      if (gerenteEscolhidos.length <= 0) {
        dadosBusca.SupervisoresId = [];
      }

      if (vendEscolhidos.length > 0) {
        dadosBusca.VendedoresId = vendEscolhidos;
      } else if (supEscolhidos.length > 0) {
        dadosBusca.SupervisoresId = supEscolhidos;
      }
    } else {
      if (cnpj != "") {
        dadosBusca.cnpj = cnpj;
      }
      if (codigoSap != "") {
        dadosBusca.codigoSap = codigoSap;
      }
    }

    var Clientes = {
      columns: [
        {
          label: "Supervisor",
          field: "supervisor",
          sort: "asc",
          width: 10,
        },
        {
          label: "Vendedor",
          field: "vendedor",
          sort: "asc",
          width: 100,
        },
        {
          label: "Cliente",
          field: "cliente",
          sort: "asc",
          width: 150,
        },
        {
          label: "Código SAP",
          field: "codigoSap",
          sort: "asc",
          width: 150,
        },
        {
          label: "Proprietário",
          field: "proprietario",
          sort: "asc",
          width: 100,
        },
        {
          label: "Status Cadastral",
          field: "cpfProp",
          sort: "asc",
          width: 100,
        },
        {
          label: "Status",
          field: "status",
          sort: "asc",
          width: 100,
        },
        {
          label: "Meta",
          field: "meta",
          sort: "asc",
          width: 80,
        },
        {
          label: "Realizado",
          field: "realizado",
          sort: "asc",
          width: 80,
        },
        {
          label: "Faixa",
          field: "faixa",
          sort: "asc",
          width: 80,
        },
        {
          label: "Farol",
          field: "farol",
          sort: "asc",
          width: 80,
        },
        {
          label: "Consultar",
          field: "consultar",
          sort: "asc",
          width: 80,
        },
        {
          label: "Detalhes",
          field: "detalhes",
          sort: "asc",
          width: 180,
        },
      ],
      rows: [],
    };

    if(PushId) {
      dadosBusca.PushId = PushId;
    }

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dadosBusca),
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Vendedores/ProcurarTotais`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso) {

          var colExcel = [];
          result.listaLojas.map((cliente) => {
            if (cliente.cpfProp) {
              var cpf = btoa(cliente.cpfProp);
            }

            Clientes.rows.push({
              supervisor: cliente.supervisor,
              vendedor: cliente.vendedor,
              cliente: cliente.cliente,
              codigoSap: cliente.sap,
              proprietario: cliente.proprietario,
              cpfProp: cliente.cpfProp == null ? "Sem cadastro" : "Cadastrada",
              statusCadastral: cliente.statusCadastral,
              status: cliente.status,
              meta: cliente.meta,
              realizado: cliente.realizado,
              faixa: cliente.faixa,
              farol: <div className={"bola " + cliente.farol}></div>,
              DataUltimoAcesso: cliente.dataUltimoAcesso,
              DataUltimoResgate: cliente.dataUltimoResgate,
              consultar:
                cliente.cpfProp != null ? (
                  <MDBBtn
                    className="botao-consultar"
                    onClick={() => history.push(`/ConsultarClientes/${cpf}`)}
                  >
                    Consultar
                  </MDBBtn>
                ) : (
                  ""
                ),
              detalhes: (
                <MDBBtn
                  className="botao-detalhes"
                  onClick={() => toggle(cliente)}
                >
                  Detalhes
                </MDBBtn>
              ),
            });

            colExcel.push({
              supervisor: cliente.supervisor,
              vendedor: cliente.vendedor,
              cliente: cliente.cliente,
              codigoSap: cliente.sap,
              proprietario: cliente.proprietario,
              cpfProp: cliente.cpfProp == null ? "Sem cadastro" : "Cadastrada",
              statusCadastral: cliente.statusCadastral,
              status: cliente.status,
              meta: cliente.meta,
              realizado: cliente.realizado,
              faixa: cliente.faixa,
              farol: cliente.farol,
              codLoja: cliente.codLoja,
              saldoAtual: cliente.saldoAtual,
              pontosExpirados: cliente.pontosExpirados,
              qtdResgates: cliente.qtdResgates,
              pontosResgatados: cliente.pontosResgatados,
              DataUltimoAcesso: cliente.dataUltimoAcesso,
              DataUltimoResgate: cliente.dataUltimoResgate,
              consultar:
                cliente.cpfProp != null ? (
                  <MDBBtn
                    className="botao-consultar"
                    onClick={() =>
                      history.push(`/ConsultarClientes/${cliente.cpfProp}`)
                    }
                  >
                    Consultar
                  </MDBBtn>
                ) : (
                  ""
                ),
            });
          });

          setClientes(Clientes);
          setColunasExcel(colExcel);
        } else {
          limpaState();

          if (tipo !== "SAP" && departamento === 11) {
            buscaVendedores();
          }

          if (tipo === "SAP") {
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: result.mensagem,
            });
          }
        }

        setCarregando(false);
      })
      .catch((error) => {
        console.log("error", error);
        Swal.fire({
          icon: "error",
          title: "Atenção!",
          text: "Erro ao carregar as informações, tente novamente.",
        });
        setCarregando(false);
      });
  }

  function verificaLogin() {
    if (TOKEN === null) {
      history.push({ pathname: "/", state: {} });
      setCarregando(false);
    } else {
      LogAcesso(TOKEN, "Academia Bunge");
    }
  }

  function limpaState() {
    setClientes([]);
  }

  useEffect(() => {
    document.title = "Plataforma Vendedor | Consulta de Cadastros";

    document.body.style.overflow = "auto";

    verificaLogin();
    buscaVendedores();

    return () => {
      document.body.style.overflow = "hidden";
    };
  }, []);

  useEffect(() => {
    if (vendEscolhidos.length > 0) {
      carregaLojas();
    }
  }, [vendEscolhidos]);


  return (
    <>
      <HeaderPortalVendedor />
      <MenuPrinc />
      <Container>
        {carregando && <Carregando />}
        <HomeFornada>
          <div className="clear"></div>

          <div className="cadastros">
            <TituloPagina>{title || 'Consulta de cadastros com filtro'}</TituloPagina>

            <MDBBtn
              size="sm"
              color="info"
              onClick={() => history.push("/Home")}
            >
            <HiOutlineArrowSmLeft style={{ fontSize: "17px" }} />
              Voltar
            </MDBBtn>

            <div id="resultado">
              <ExcelFile
                element={
                  clientes.length !== 0 && (
                    <MDBBtn
                      color="primary"
                      size="sm"
                      style={{ float: "right" }}
                    >
                      Baixar em Excel
                    </MDBBtn>
                  )
                }
              >
                <ExcelSheet data={colunasExcel} name="Employees">
                  <ExcelColumn label="Supervisor" value="supervisor" />
                  <ExcelColumn label="Vendedor" value="vendedor" />
                  <ExcelColumn label="Cliente" value="cliente" />
                  <ExcelColumn label="Código SAP" value="codigoSap" />
                  <ExcelColumn label="Proprietário" value="proprietario" />
                  <ExcelColumn
                    label="Status Cadastral"
                    value="statusCadastral"
                  />
                  <ExcelColumn label="Meta" value="meta" />
                  <ExcelColumn label="Realizado" value="realizado" />
                  <ExcelColumn label="Faixa" value="faixa" />
                  <ExcelColumn label="Farol" value="farol" />
                  <ExcelColumn label="Qtd Resgate" value="qtdResgates" />
                  <ExcelColumn
                    label="Pontos Resgatados"
                    value="pontosResgatados"
                  />
                  <ExcelColumn label="Saldo Atual" value="saldoAtual" />
                  <ExcelColumn
                    label="Pontos Expirados"
                    value="pontosExpirados"
                  />
                  <ExcelColumn label="Ultimo Acesso" value="dataUltimoAcesso" />
                  <ExcelColumn
                    label="Ultimo Resgate"
                    value="dataUltimoResgate"
                  />
                  <ExcelColumn label="Cod Loja" value="codLoja" />
                </ExcelSheet>
              </ExcelFile>

              <br />

              {clientes.length !== 0 ? (
                <div className="tabresp">
                  <MDBDataTable
                    striped
                    bordered
                    hover
                    searchLabel="Pesquisar"
                    paginationLabel={["Anterior", "Próximo"]}
                    noRecordsFoundLabel="Nenhum resultado encontrado"
                    infoLabel={["Mostrando", "de", "até", "registros"]}
                    entriesLabel="Qtd por pagina"
                    data={clientes}
                  />
                </div>
              ) :
							!carregando && 
							<h3 style={{ textAlign: 'center', color: '#333333' }}>Nenhum cliente foi encontrado!</h3>
						}
            </div>
          </div>

          <MDBModal isOpen={abreModal} toggle={() => toggle()} size="lg">
            <MDBModalHeader toggle={() => toggle()}>
              <h6>
                Detalhes da loja <strong>{listaSelect.cliente}</strong>
              </h6>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBCol>
                  <MDBTable striped>
                    <MDBTableHead>
                      <tr>
                        <th>Código Loja</th>
                        <th>Saldo Atual</th>
                        <th>Pontos Expirados</th>
                        <th>Qtd Resgates</th>
                        <th>Pts Resgatados</th>
                        <th>Ultimo acesso</th>
                        <th>Ultimo Resgate</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      <tr>
                        <td>{listaSelect.codLoja}</td>
                        <td>{listaSelect.saldoAtual}</td>
                        <td>{listaSelect.pontosExpirados}</td>
                        <td>{listaSelect.qtdResgates}</td>
                        <td>{listaSelect.pontosResgatados}</td>
                        <td>{listaSelect.dataUltimoAcesso}</td>
                        <td>{listaSelect.dataUltimoResgate}</td>
                      </tr>
                    </MDBTableBody>
                  </MDBTable>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter></MDBModalFooter>
          </MDBModal>
        </HomeFornada>
      </Container>
    </>
  );
}

export default FiltroPush;
